import {
	tlISODateToLocalString, Watch, EnumsService, EnumsFilter, SettingService, SettingFilter, tlISOTimeToLocalStringForm, tlISODateTimeToLocalNoSecondsString, BaseTLDetailComponent, AxiosResponse, ObjectTypesHelper, tlISODateToLocalStringForm, tlLogDebugString, tlLogDebug
} from "../../../Infrastructure/CorBase/CoreBase";
import { ContentFilter, ContentService, TaskPartService, TaskBlockFilter,TaskBlockService, TaskPartFilter, ReceiverService, ReceiverFilter, TaskService } from "../../../Services/ContBase/AllConServices";
	import TagModal from "../../../Components/ComponentsBase/BaseTLModalDialogTag.vue";
	import ModalDetail from "../../../Components/ComponentsBase/BaseTLModalDialogDetail.vue";


	interface iFormDataDay {
		key: string;
		name: string;
		selected: boolean;
	}

	interface iFormDataWeek {
		monday: iFormDataDay;
		tuesday: iFormDataDay;
		wednesday: iFormDataDay;
		thursday: iFormDataDay;
		friday: iFormDataDay;
		saturday: iFormDataDay;
		sunday: iFormDataDay;
	}

 interface iFormDataContentHead {
	 isEditContentDetail: boolean;
	 isAllowException: boolean;
	id: number;
	idNew: number;
	isNewBlock: boolean;
	name: string;
	description: string;
	inTheBackground: boolean;
	inTheInfoLine: boolean;
	timeFrom: string;
	timeTo: string;
	week: iFormDataWeek;
	exceptionText: string;
	idSchedule: number;
	idTask: number;
	contents: iFormDataContent[];
};

	interface iFormDataContent {
		id: number;
		idTenant: number;
		duration: string;
		exceptionText: string;
		icon: string;
		mute: boolean;
		streamBufferInSeconds: number | null;
		backgroundColor: string;
		idContent: number;
		idContentNavigationName: string;
		idContentTypeNavigationIdentifier: string;
		idContentTypeNavigationName: string;
		idDisplayMode: number;
		idSchedule: number;
		idTask: number;
		image: number;
		order: number;

		idContentPreviewGridStatic: number;
		idContentPreviewGridAnimated: number;
		idContentPreviewTableStatic: number;
		idContentPreviewTableAnimated: number;
		contentPreviewAlt: string;
		contentPreviewTitle: string;

		inTheBackground: boolean;
		refreshInterval: string;
		suppressBackground: boolean;
		showWarningInOffline: boolean;
		//informacni text

		inTheInfoLine: boolean;
		idInfoPosition: number | null;
		idInfoRotationDirection: number | null;
		idInfoRotationSpeed: number | null;
		idInfoSize: number | null;
		textColor: string;
		delay: number | null;

		isCanceled: boolean;
		idCancelationReason: number | null;
		idCancelationReasonText: string ;
};

export default abstract class TaskDetailBase extends BaseTLDetailComponent {
	taskService: TaskService = new TaskService();
	receiverService: ReceiverService = new ReceiverService();
	taskPartService: TaskPartService = new TaskPartService();
	contentService: ContentService = new ContentService();
	settingService: SettingService = new SettingService();
	enumService: EnumsService = new EnumsService();
	taskBlockService: TaskBlockService = new TaskBlockService();

	returnRoute = "TaskList";
	activeTabName: string = '';
	objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Receiver;
	objectTypeReceiver: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Receiver;
	objectTypeContent: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Content;
	protected objectTypeTaskPart: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.TaskPart;

	isBusyContent = false;
	isBusyReceiver = false;
	isDeletedBlock = false;

	descriptionCountItem = '';
	//přehravane obrazovky
	protected isEditReceiverDetail = false;

	receivers: any[] = [];
	receiversOld: any[] = [];
	receiversAll: any[] = [];

	SET_ID_DisplayMode = 0;
	SET_Display_Image = '00:00:00';
	SET_Display_Html = '00:00:00';
	SET_Display_Url = '00:00:00';
	SET_Refresh_Url = '00:00:00';
	SET_Refresh_InfoText = '00:00:00';
	SET_Display_Other = '00:00:00';
	SET_Video_Length = '00:00:00';

	SET_idInfoPosition = 0;
	SET_idInfoRotationDirection = 0;
	SET_idInfoRotationSpeed = 0;
	SET_idInfoSize = 0;

	//potřeba refresh při změně jazyka, když je to modal oknech	
	changeFieldsAfterChangeLanguageBase(value: boolean, oldValue: boolean) {
		this.filtersContentModalInfo = this.changeTranslate(this.filtersContentModalInfo);
		this.filtersContentModal = this.changeTranslate(this.filtersContentModal);
		this.fieldsReceiverModal = this.changeTranslate(this.fieldsReceiverModal);
		this.filtersReceiverModal = this.changeTranslate(this.filtersReceiverModal);
		//this.formDataContentHead = [];
		this.fetchData();

		this.loadContentsBlock();

		//this.loadContents();
		this.loadReceivers();
	}

	//roztrideni 
	getContents(contents: [iFormDataContent], inTheInfoLine: boolean) {
		return contents == null? []: contents.filter((c: iFormDataContent) => c.inTheInfoLine == inTheInfoLine);
	}

	lastIdComponent = 0;
	addNewTag(item: any) {
		this.$bvModal.show('tagDialog');
		this.lastIdComponent = Number(item.id);
		(this.$refs.tagModal as TagModal).setSelected(item.tags, this.lastIdComponent, item.name);
	}

	gridColor(color: string): string {
		return 'background-color: ' + color + ';';
	}

	//TODO tohle je i v baseTlTalbe - sjednotit
	changeTagsBase(items: any): void {
		this.formData.tags = items;
	}

	goBackDetailTagBase(item: any): void {
		let tags: any = this.formData.tags;
		if (tags != null) {
			let changeItem = tags.filter((c: any) => c.id == item.id)[0];
			changeItem.name = item.name;
			changeItem.color = item.color;
		}
	}

	tagDetail(item: any): void {
		this.$bvModal.show('detailModal');
		(this.$refs.detailModal as ModalDetail).setSelected(String(item.id));
	}

	isAllowAdd(): boolean {
		return this.formData.id > 0;
	}

	protected async createObject(): Promise<AxiosResponse<any>> {
		var result = await this.taskService.create(this.formData)
		this.afterCreateChangeUrl(result.data.id);
		return result;
	}

	protected changeInputBase(order: number, key: string, value: any) {

		this.isEditContentDetail = true;
		let content: iFormDataContent = this.contents.filter((c: iFormDataContent) => c.order == order)[0];
		let keyAsAny: any = key as any;
		this.setProperty(content, keyAsAny, value);

	}

	anyChangeBase(id: any) {
		var formDataHead = this.formDataContentHead.filter(c => c.id == id)[0];
		formDataHead.isEditContentDetail = this.isEditContentDetail = true;
	}

	//TODO HEAD
	protected changeCheckboxHeadBase(key: any, idTable: any) {
		if (key == 'audio') {
			this.isEditContentDetail = true;
			var formDataHead = this.formDataContentHead.filter(c => c.id == idTable)[0];
			formDataHead.inTheBackground = !formDataHead.inTheBackground;
			formDataHead.isEditContentDetail = true;
			this.changeOrderNumber(formDataHead);
		}
		if (key == 'inTheInfoLine') {
			this.isEditContentDetail = true;
			var formDataHead = this.formDataContentHead.filter(c => c.id == idTable)[0];
			formDataHead.inTheInfoLine = !formDataHead.inTheInfoLine;
			formDataHead.isEditContentDetail = true;
			//if (formDataHead.inTheInfoLine == false) {
			//	formDataHead.contents =  formDataHead.contents.filter(c => c.inTheInfoLine == false);
			//}
		}
		//	this.setProperty(this.formDataContentHead, key, !this.getProperty(this.formDataContentHead, key));

	}
	//TODO tady nechapu proc tohle nezabira kdyz zmenim nazev bloku a dam to zpet.... 
	public isChangeContent() {
		
		//NEZABIRA
		var now = JSON.stringify(this.formDataContentHead).trim();
		var old = JSON.stringify(this.formDataContentHeadOld).trim()

		return now != old;
	}


	protected changeCheckboxListHeadBase(dayKey: any, order: any, key: any, idTable: any) {
		this.isEditContentDetail = true;

		var formDataHead = this.formDataContentHead.filter(c => c.id == idTable)[0];
		var dayChange = this.getProperty(formDataHead.week, dayKey);
		formDataHead.isEditContentDetail = true;
		dayChange.selected = !dayChange.selected;
	}

	protected changeCheckboxBase(id: any, order: any, key: any, idTable: any) {
		this.isEditContentDetail = true;

		var formDataHead = this.formDataContentHead.filter(c => c.id == idTable)[0];
		formDataHead.isEditContentDetail = true;

		let content = formDataHead.contents.filter((c: any) => c.id == id)[0];
		this.setProperty(content, key, !this.getProperty(content, key));
	}

	getProperty<T, K extends keyof T>(o: T, propertyName: K): T[K] {
		//viz zde https://www.nadershamma.dev/blog/2019/how-to-access-object-properties-dynamically-using-bracket-notation-in-typescript/
		return o[propertyName];
	}

	setProperty<T, K extends keyof T>(o: T, propertyName: K, value: any) {
		//viz zde https://www.nadershamma.dev/blog/2019/how-to-access-object-properties-dynamically-using-bracket-notation-in-typescript/
		let property = o[propertyName];
		if (property != undefined) {
			o[propertyName] = value;
		}
	}

	protected moveUpBase(idOrder: any, idTable: any, isInfoText: boolean) {
		var formHeadOne = this.formDataContentHead.filter(c => c.id == idTable)[0];
		formHeadOne.isEditContentDetail = this.isEditContentDetail = true;
		this.isEditContentDetail = true;
		let itemUp = formHeadOne.contents.filter((c: iFormDataContent) => c.order == idOrder && c.inTheInfoLine == isInfoText)[0] as iFormDataContent;
		let itemDown = null;
		let order = itemUp.order;
		var contents = formHeadOne.inTheBackground ? formHeadOne.contents.filter((c: iFormDataContent) => c.inTheBackground == itemUp.inTheBackground && c.inTheInfoLine == isInfoText) : formHeadOne.contents.filter((c: iFormDataContent) => c.inTheInfoLine == isInfoText);
		if (contents.filter((c: iFormDataContent) => c.order < order).length == 0) {
			itemDown = contents.reduce((prev: iFormDataContent, current: iFormDataContent) => (prev.order > current.order) ? prev : current);
		}
		else {
			itemDown = contents.filter((c: iFormDataContent) => c.order < order).reduce((prev: iFormDataContent, current: iFormDataContent) => (prev.order > current.order) ? prev : current);
		}

		let orderUp = itemUp.order;
		let orderDown = itemDown.order;
		itemDown.order = orderUp;
		itemUp.order = orderDown;
	}

	protected moveDownBase(idOrder: any, idTable: any, isInfoText: boolean) {
		var formHeadOne = this.formDataContentHead.filter(c => c.id == idTable)[0];
		formHeadOne.isEditContentDetail = this.isEditContentDetail = true;
		let itemUp: iFormDataContent;
		let itemDown = formHeadOne.contents.filter((c: iFormDataContent) => c.order == idOrder && c.inTheInfoLine == isInfoText)[0] as iFormDataContent;	
		let order = itemDown.order;
		var contents = formHeadOne.inTheBackground ? formHeadOne.contents.filter((c: iFormDataContent) => c.inTheBackground == itemDown.inTheBackground && c.inTheInfoLine == isInfoText) : formHeadOne.contents.filter((c: iFormDataContent) => c.inTheInfoLine == isInfoText);
	
		if (contents.filter((c: iFormDataContent) => c.order > order).length == 0) {
			itemUp = contents.reduce((prev: any, current: iFormDataContent) => (prev.order > current.order) ? current : prev);
		}
		else {
			itemUp = contents.filter((c: iFormDataContent) => c.order > order).reduce((prev: iFormDataContent, current: iFormDataContent) => (prev.order > current.order) ? current : prev);
		}

		let orderUp = itemUp.order;
		let orderDown = itemDown.order;
		itemDown.order = orderUp;
		itemUp.order = orderDown;
	}

	protected changeCheckboxListBase(dayKey: any, order: any, key: any) {
		this.isEditContentDetail = true;
		let finalKey: string = 'selected';

		let content: iFormDataContent = this.contents[0];
		this.setProperty(this.getProperty(this.getProperty(content, key), dayKey), finalKey, !this.getProperty(this.getProperty(this.getProperty(content, key), dayKey), finalKey));
	}

	protected deleteReceiverDetailBase(item: any) {
		this.isEditReceiverDetail = true;
		this.receivers = (this.receivers as Array<any>).filter(d => d.id != item) as [];
		
	}

	protected addReceiverDetailBase(): void {
		this.initAllReceivers();
		this.$bvModal.show('reciverModal');
	}

	async saveReceiversDetail(delegate: boolean): Promise<boolean> {
		try {
			var result = await this.receiverService.updateReceiversToTask(this.formData.id, this.receivers);
			if (result.status == 204) {
				this.isEditReceiverDetail = false;
				this.receiversOld = [];
				this.receivers.forEach(val => this.receiversOld.push(Object.assign({}, val)));
				if (delegate == true) {
					//delegovani se spusti a podruhe to hodi chybu ReceiverService - UpdateReceiverToTask 
					this.onlyDelegate();
				}
				return true;
			}
			else {
				return false;
			}
		}
		catch (error) {
			this.isEditReceiverDetail = false;
			const obj = JSON.stringify(error);
			var er = JSON.parse(obj);
			var message = er.data == "" ? error : er.data;
			this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSave').toString(), message);
		};

		return false;
	}

	goBackReceiversDetail(): void {
		this.isEditReceiverDetail = false;
		this.receivers = [];
		this.receiversOld.forEach(val => this.receivers.push(Object.assign({}, val)));
	}

	selectedReceiverItemsBase(items: any): void {
		for (var i = 0; i < items.length; i++) {
			if (this.receivers.filter((c: any) => c.id == items[i]).length == 0) {
				this.isEditReceiverDetail = true;
				this.receivers.push(this.receiversAll.filter((c: any) => c.id == items[i])[0]);
				(this.receivers.filter((c: any) => c.id == items[i])[0] as any).progressHelp = 'WWWW';
			}
		}
	}

	//load do modalni nabidky
	initAllReceivers(): void {
		let filter: ReceiverFilter = new ReceiverFilter(this.$store.state.idTenant, false, null, null, null, null, null);
		this.receiverService.getAllByFilter(filter).then(response => {
			this.receiversAll = [];
			for (var i = 0; i < response.data.length; i++) {
				if (this.receivers.filter(c => c.id == response.data[i].id).length == 0) {
					this.receiversAll.push(Object(response.data[i]));					
				}
			}
		});
	}

	loadReceivers() {
		let filterRec: ReceiverFilter = new ReceiverFilter(this.$store.state.idTenant, false, null, this.paramId(), null, null, null, null, null, this.$store.state.isSuperUser);
		this.isBusyReceiver = true;
		this.receiverService.getAllByFilter(filterRec).then(response => {
			this.receivers = response.data;
			this.receivers.forEach(val => this.receiversOld.push(Object.assign({}, val)));
			this.descriptionCountItem = (response.data as Array<any>).length == 0? '':(response.data as Array<any>).length.toString();
			this.isBusyReceiver = false;
		})
	}

	protected modalNameReceiver(): string {
		return this.$t('taskDetail.addReceiverToTask').toString() + this.formData.name;
	}

	fieldsReceiver = [
		{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-left helpPaddingLeft30', design: 'popupImage', action: 'notClick' },
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', sortable: true, class: 'text-left ', optional: false, visible: true, design: 'detail' },
		{ key: 'idComponentStateNavigationName', label: this.$t('taskDetail.fieldStatus'), trans: 'taskDetail.fieldStatus', sortable: true, class: 'text-left helpWidth250' , optional: false, visible: true, design: 'componentState' },
		{ key: 'taskActual', label: this.$t('taskDetail.fieldActualPlay'), trans: 'taskDetail.fieldActualPlay', sortable: true, class: 'text-left helpWidth400 ', optional: false, visible: true, design: 'link', action: 'notClick' },
		{ key: 'progressHelp', label: this.$t('taskDetail.fieldProgress'), trans: 'taskDetail.fieldProgress', sortable: false, class: 'text-left', design: 'icons', tooltip: 'progressError' },
		{ key: 'actions', label: '', class: 'text-right' }
	];

	fieldsReceiverModal = [
		{ key: 'id', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center columnImage', design: 'popupImage' ,action: 'notClick'},
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', sortable: true, class: 'text-center', optional: false, visible: true},
		{ key: 'idComponentStateNavigationName', trans: 'taskDetail.fieldStatus', label: this.$t('taskDetail.fieldStatus'), sortable: true, class: 'text-left helpWidth250', optional: false, visible: true, design: 'componentState' },
		{ key: 'taskActual', label: this.$t('taskDetail.fieldActualPlay'), trans: 'taskDetail.fieldActualPlay', sortable: true, class: 'text-center', optional: false, visible: true, design: 'link' },
		{ key: 'idComponentStateNavigation', trans: 'taskDetail.fieldId', label: 'Název', sortable: true, class: 'text-center', optional: true, visible: false, show: false },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', sortable: true, class: 'text-left', design: 'tags', action: 'filter' },
	];

	filtersReceiverModal = [
		
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', selected: false, value: null, type: 'multi', multiselect: true },
		//TODO predelat
		{ key: 'idComponentState1', label: this.$t('taskDetail.fieldComponentNew'), trans: 'taskDetail.fieldComponentNew', selected: true, value: 'ENU_COR_Component_State_New', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState2', label: this.$t('taskDetail.fieldComponentProvisioning'), trans: 'taskDetail.fieldComponentProvisioning', selected: true, value: 'ENU_COR_Component_State_Provisioning', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState3', label: this.$t('taskDetail.fieldComponentIdle'), trans: 'taskDetail.fieldComponentIdle', selected: true, value: 'ENU_COR_Component_State_Idle', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState4', label: this.$t('taskDetail.fieldComponentLost'), trans: 'taskDetail.fieldComponentLost', selected: true, value: 'ENU_COR_Component_State_Lost', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState5', label: this.$t('taskDetail.fieldComponentActive'), trans: 'taskDetail.fieldComponentActive', selected: true, value: 'ENU_COR_Component_State_Active', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState6', label: this.$t('taskDetail.fieldComponentDisabled'), trans: 'taskDetail.fieldComponentDisabled', selected: true, value: 'ENU_COR_Component_State_Disabled', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState7', label: this.$t('taskDetail.fieldComponentDisabling'), trans: 'taskDetail.fieldComponentDisabling', selected: true, value: 'ENU_COR_Component_State_Disabling', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState8', label: this.$t('taskDetail.fieldComponentFailed'), trans: 'taskDetail.fieldComponentFailed', selected: true, value: 'ENU_COR_Component_State_ProvisioningFailed', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState9', label: this.$t('taskDetail.fieldComponentProvisioned'), trans: 'taskDetail.fieldComponentProvisioned', selected: true, value: 'ENU_COR_Component_State_Provisioned', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState10', label: this.$t('taskDetail.fieldComponentActivating'), trans: 'taskDetail.fieldComponentActivating', selected: true, value: 'ENU_COR_Component_State_Activating', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true },
		{ key: 'idComponentState11', label: this.$t('taskDetail.fieldComponentStopping'), trans: 'taskDetail.fieldComponentStopping', selected: true, value: 'ENU_COR_Component_State_Stopping', type: 'text', group: true, groupId: 'idComponentStateNavigation', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Status', isNegative: true }

	];

	//end prehravene obrazovky


	// prehravene MEDIA

	formDataDay = {
		key: '' as string,
		name: '' as string,
		selected: false as boolean
	}

	formDataWeek = {
		monday: this.formDataDay,
		tuesday: this.formDataDay,
		wednesday: this.formDataDay,
		thursday: this.formDataDay,
		friday: this.formDataDay,
		saturday: this.formDataDay,
		sunday: this.formDataDay,
	}

	formDataContent = {
		id: 0 as number,
		duration: '' as string,
		exceptionText: '' as string,
		mute: false as boolean,
		streamBufferInSeconds: 0 as number | null,
		backgroundColor: '' as string,
		idContent: 0 as number,
		idContentNavigationName: '' as string,
		idContentTypeNavigationIdentifier: '' as string,
		idContentTypeNavigationName: '' as string,
		idDisplayMode: 0 as number,
		idSchedule: 0 as number,
		idTask: 0 as number,
		image: 0 as number,
		order: 0 as number,

		idContentPreviewGridStatic: 0 as number,
		idContentPreviewGridAnimated: 0 as number,
		idContentPreviewTableStatic: 0 as number,
		idContentPreviewTableAnimated: 0 as number,
		contentPreviewAlt: '' as string,
		contentPreviewTitle: '' as string,

		inTheBackground: false as boolean,
		refreshInterval: '' as string,
		suppressBackground: false as boolean,
		showWarningInOffline: true as boolean,
		timeFrom: '' as string,
		timeTo: '' as string,
		week: this.formDataWeek,
		isCanceled: false,
		idCancelationReason: 0,
		idCancelationReasonText:''
	};

	formDataContentHead: iFormDataContentHead[] = [];
	formDataContentHeadOld: iFormDataContentHead[] = [];
	formDataContentHeadSettingOld: iFormDataContentHead[] = [];

	isEditContentDetail = false;

	//to je object tasPart
	contents: iFormDataContent[] = [];


	contentsOld: iFormDataContent[] = [];
	contentsOldSetting: iFormDataContent[] = [];
	//to je contents - dat pryc
	contentsAll: iFormDataContent[] = [];
	loadContents() {

		let filter: TaskPartFilter = new TaskPartFilter(this.paramId());
		this.isBusyContent = true;
		this.taskPartService.getAllByFilter(filter).then(response => {
			this.contents = response.data;
			if (this.contents.length > 0) {


				//uprava orderu kdyz nejsou vyplneny
				var maxOrder = this.contents.reduce((prev: any, current: any) => (prev.order > current.order) ? prev : current);
				var actualOrder = maxOrder.order;
				var noOrderList = this.contents.filter(c => c.order == null);
				for (var i = 0; i < noOrderList.length; i++) {
					actualOrder++;
					noOrderList[i].order = actualOrder;
				}
				//nezbytne nebot pak to nejde zmenit funkci setProperty

				//TODO tohle dat jinde
                //for (var a = 0; a < this.contents.length; a++) {
                //    if (this.contents[a].timeFrom == null) {

                //        this.contents[a].timeFrom = '00:00';
                //        this.contents[a].timeTo = '23:59';
                //    }
                //    else {
                //        this.contents[a].timeTo = this.contents[a].timeTo.substring(0, 5);
                //        this.contents[a].timeFrom = this.contents[a].timeFrom.substring(0, 5);
                //    }
                //}

				this.contents.forEach(val => this.contentsOld.push(Object.assign({}, val)));
				//TODO tohle jsem musel samostatne protoze to nad tim to nezvladlo subObject
				//this.contents.forEach(val => this.weekOld.push({ id: val.id, week: JSON.parse(JSON.stringify(val.week)) }));
			}
			this.isBusyContent = false;
		})
	}


	loadContentsBlock() {

		let filter: TaskBlockFilter = new TaskBlockFilter(this.paramId());
		this.isBusyContent = true;
		this.taskBlockService.getAllByFilter(filter).then(response => {
			this.formDataContentHead = response.data;
			for (var a = 0; a < this.formDataContentHead.length; a++) {
				this.formDataContentHead[a].isAllowException = this.allowEditBlockBase();
				if (this.formDataContentHead[a].timeFrom == null) {

					this.formDataContentHead[a].timeFrom = '00:00';
					this.formDataContentHead[a].timeTo = '23:59';
				}
				else {
					this.formDataContentHead[a].timeTo = this.formDataContentHead[a].timeTo.substring(0, 5);
					this.formDataContentHead[a].timeFrom = this.formDataContentHead[a].timeFrom.substring(0, 5);
				}
			}

			this.formDataContentHeadOld = [];
			this.formDataContentHead.forEach(val => this.formDataContentHeadOld.push(Object.assign({}, this.deepCopy(val))));
	
			this.isBusyContent = false;
		})
	}

	newTaskPartInBackground = false;
	initAllContents(idTable: number, onlyAudio: boolean, isInfotext: boolean): void {
		this.newTaskPartInBackground = onlyAudio;
		let filter: ContentFilter = new ContentFilter(this.$store.state.idTenant, false);
		var formDataContentHeadOne = this.formDataContentHead.filter(c => c.id == idTable)[0];
		this.contentService.getAllByFilter(filter).then(response => {
			this.contentsAll = [];
			for (var i = 0; i < response.data.length; i++) {
				if (isInfotext) {
					if ((response.data[i].idContentTypeIdentifier == "ENU_CON_Content_Type_Nothing"
						|| response.data[i].idContentTypeIdentifier == "ENU_CON_Content_Type_InfoText")
					) {
						this.contentsAll.push(response.data[i]);
					}
				}
				else {
					if (response.data[i].idContentTypeIdentifier != "ENU_CON_Content_Type_InfoText" &&
						(!formDataContentHeadOne.contents.some(c => c.idContent == response.data[i].id && c.inTheBackground == onlyAudio)
						&& (onlyAudio == false || (response.data[i].idContentTypeIdentifier == "ENU_CON_Content_Type_AudioStream"
							|| response.data[i].idContentTypeIdentifier == "ENU_CON_Content_Type_Audio"
						|| response.data[i].idContentTypeIdentifier == "ENU_CON_Content_Type_Nothing" )))
					) {
						this.contentsAll.push(response.data[i]);
					}
				}
			}
		});
	}

	modalNameContent(): string {
		return this.$t('taskDetail.addContentToTask').toString() + this.formData.name;
	}

	setProgressIconsReceiverToStart() {
		for (var i = 0; i < this.receivers.length; i++) {
			(this.receivers[i] as any).progressHelp = 'WWWW';
		}
	}

	deleteContentDetailBase(item: any, idTable: any) {
		var formDataOne = this.formDataContentHead.filter(c => c.id == idTable)[0];
		formDataOne.isEditContentDetail = this.isEditContentDetail = true;
		this.setProgressIconsReceiverToStart();
		formDataOne.contents = (formDataOne.contents).filter(d => d.id != item) as [];
	}

	idTableAdd = -1;
	addContentDetailBase(idTable: any) {
		this.initAllContents(idTable,false,false);
		this.idTableAdd = idTable;
		this.$bvModal.show('contentModal');
	}

	formDataSubMenu = {
		id: 0 as number,
		idContent: 0 as number,
		idSchedule: 0 as number,
		idTask: 0 as number,
		duration: '' as string,
		refreshInterval: '' as string | null,
		exceptionText: '' as string,
		mute: false as boolean,
		streamBufferInSeconds: 0 as number | null,
		showWarningInOffline: true as boolean,
		idDisplayMode: null as number | null,
		backgroundColor: '' as string
	};

	protected startSettingMenuBase(): void {
		this.contentsOldSetting = [];
		this.contents.forEach(val => this.contentsOldSetting.push(Object.assign({}, val)));
		//TODO tady upravit
		this.formDataContentHeadSettingOld = JSON.parse(JSON.stringify(this.formDataContentHead));
	}

	//ulozeni detailu jednotliveho radku
	saveSubMenuSettingBase(idTable: any, isInfoText: boolean) {
		var formDataOne = this.formDataContentHead.filter(c => c.id == idTable)[0];
		formDataOne.contents.filter(c => c.streamBufferInSeconds == null || c.streamBufferInSeconds == undefined || c.streamBufferInSeconds.toString() == '').forEach(c => c.streamBufferInSeconds = 0);
		formDataOne.isEditContentDetail = this.isEditContentDetail = true;
	}

	//kdyz udelam zrusit nebo krizek v setting menu tak zrusit co jsem tam vybral nebo zapsal
	goBackSubMenuSettingBase(id: any) {
		//tohle rusilo vyber.... nevim proc to tu takhle bylo necham
		this.contents = [];
		this.contentsOldSetting.forEach(val => this.contents.push(Object.assign({}, val)));
		this.formDataContentHead = JSON.parse(JSON.stringify(this.formDataContentHeadSettingOld));
	}

	//když je 0 znamena uloži pro vsechny
	async saveContentBlockDetailBase(id: any, saveAll: boolean, delegate: boolean = false, delegateAndActivate:boolean = false): Promise<boolean> {
		try {
			this.isDeletedBlock = false;
			//pred ulozenim musi pohlidat ze tyto udeaje nejsou zaporne (potrebuju je zaporne kvuli inicializaci, ale ne vsechny to potrebuji)
			for (var a = 0; a < this.formDataContentHead.length; a++) {
				if (this.formDataContentHead[a].inTheInfoLine == false) {
					this.formDataContentHead[a].contents = this.formDataContentHead[a].contents.filter(c => c.inTheInfoLine == false);
				}

				if (this.formDataContentHead[a].contents != null) {
					for (var ab = 0; ab < this.formDataContentHead[a].contents.length; ab++) {
						
						//if (this.formDataContentHead[a].inTheInfoLine == false) {
						//	this.formDataContentHead[a].contents.filter(c => c.inTheInfoLine == false);
						//}
						

						if (this.formDataContentHead[a].contents[ab].inTheInfoLine) {
							this.formDataContentHead[a].contents[ab].idInfoPosition = Number(this.formDataContentHead[a].contents[ab].idInfoPosition) < 0 ? this.SET_idInfoPosition : this.formDataContentHead[a].contents[ab].idInfoPosition;
							this.formDataContentHead[a].contents[ab].idInfoRotationDirection = Number(this.formDataContentHead[a].contents[ab].idInfoRotationDirection) < 0 ? this.SET_idInfoRotationDirection : this.formDataContentHead[a].contents[ab].idInfoRotationDirection;
							this.formDataContentHead[a].contents[ab].idInfoRotationSpeed = Number(this.formDataContentHead[a].contents[ab].idInfoRotationSpeed) < 0 ? this.SET_idInfoRotationSpeed : this.formDataContentHead[a].contents[ab].idInfoRotationSpeed;
							this.formDataContentHead[a].contents[ab].idInfoSize = Number(this.formDataContentHead[a].contents[ab].idInfoSize) < 0 ? this.SET_idInfoSize : this.formDataContentHead[a].contents[ab].idInfoSize;
						}
						else {
							

							this.formDataContentHead[a].contents[ab].idInfoPosition = null;
							this.formDataContentHead[a].contents[ab].idInfoRotationDirection = null;
							this.formDataContentHead[a].contents[ab].idInfoRotationSpeed = null;
							this.formDataContentHead[a].contents[ab].idInfoSize = null;
						}

					}
				}
			}  
			//ulozeni jednoho bloku
			if (!saveAll) {

				var formDataHead = this.formDataContentHead.filter(c => c.id == id)[0];

				if (formDataHead.inTheInfoLine == false) {
					formDataHead.contents.filter(c => c.inTheInfoLine == false);
				}

				var formDataHeadOld = this.formDataContentHeadOld.filter(c => c.id == id)[0];
				var result = await this.taskBlockService.update(Number(id), formDataHead).then(res => {			
				
					formDataHead.id = res.data.id;
					formDataHead.idSchedule = res.data.idSchedule;
					formDataHead.isEditContentDetail = formDataHead.isNewBlock = false;
					this.processResponse(res.data.taskDTO);


					this.formDataContentHeadOld.push(Object.assign({}, this.deepCopy(formDataHead)));
					this.$store.commit("mainDataChanged", false);
				});
				
			}
			else {  //všechny
				this.isEditContentDetail = false; //dat to radeji hned
				 var result2 = this.taskBlockService.updateAllTaskBlock(this.formDataContentHead).then(res => {
					
					var result = res.data as Array<iFormDataContentHead>;
					for (var i = 0; i < result.length; i++) {
						if (result[i].isNewBlock) {
							var zmena = this.formDataContentHead.filter((c: iFormDataContentHead) => c.isNewBlock == true && c.id == result[i].idNew)[0];
							zmena.id = result[i].id;
						}
						this.formDataContentHead.filter((c: iFormDataContentHead) => c.id == result[i].id)[0].contents = result[i].contents;
					}
					 if (res.data.length > 0) {
						this.processResponse((res.data as Array<any>)[0].taskDTO);
					}
					for (var ax = 0; ax < this.formDataContentHead.length; ax++) {
						this.formDataContentHead[ax].idSchedule = result.filter((c: iFormDataContentHead) => c.id == this.formDataContentHead[ax].id)[0].idSchedule;
                    }
					this.formDataContentHead.forEach(c => c.isEditContentDetail = false);
					this.formDataContentHead.forEach(c => c.isNewBlock = false);
				//	this.isEditContentDetail = false;
					this.formDataContentHeadOld = [];
					this.formDataContentHead.forEach(val => this.formDataContentHeadOld.push(Object.assign({}, this.deepCopy(val))));
					 this.$store.commit("mainDataChanged", false);

					 if (delegate) {
						 this.onlyDelegate();
					 }

					 if (delegateAndActivate) {
						 this.onlyActivateAndDelegate();
					 }
				 }).catch((error) => {
					this.isEditContentDetail = false;
					const obj = JSON.stringify(error);
					var er = JSON.parse(obj);
					var message = er.data == "" ? error : er.data;
					this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSave').toString(), message);
				});			
				
			}		
		}
		catch (error) {
			this.isEditContentDetail = false;
			const obj = JSON.stringify(error);
			var er = JSON.parse(obj);
			var message = er.data == "" ? error : er.data;
			this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSave').toString(), message);
			return false;
		};
		return true;
	}


	deepCopy(obj: any): any {
		if (typeof obj !== "object" || obj === null) {
			return obj;
		}
		const copy: any = Array.isArray(obj) ? [] : {};
		for (const key in obj) {

			copy[key] = this.deepCopy(obj[key]);
		}
		return copy;
	}

	//zpet vse receivery i obsah
	goBackNotChangeAllBase() {
		this.isEditReceiverDetail = false;
		this.isEditContentDetail = false;
		this.isDeletedBlock = false;
		this.loadContentsBlock();
		this.loadReceivers();

		this.goBackNotChange();
		//this.receivers = [];
		//this.receiversOld.forEach(val => this.receivers.push(Object.assign({}, val)));

		//this.isEditContentDetail = false;
		//this.formDataContentHead = [];
		//this.formDataContentHeadOld.forEach(val => this.formDataContentHead.push(Object.assign({}, val)));
	}

	goBackContentDetail(item: any): void {
		var id = item.id;

		if (this.formDataContentHeadOld.length == 0 || this.formDataContentHeadOld.some(c => c.id == id) == false) {
			this.formDataContentHead = this.formDataContentHead.filter(c => (c.id != id ));
		}
		else {
			var formDataHeadOld = this.formDataContentHeadOld.filter(c => c.id == id)[0];
			this.formDataContentHead = this.formDataContentHead.map(obj =>
				obj.id === id ? { ...this.deepCopy(formDataHeadOld), isEditContentDetail: false } : obj
			);
		}
		this.isEditContentDetail = this.formDataContentHead.some(c => c.isEditContentDetail == true);

	}

	getDay(pKey: string, pName: string): iFormDataDay {
		var result: iFormDataDay = {
			key: pKey,
			name: pName,
			selected: true
		}
		return result;
	}

	loadSetting() {

		let enumService: EnumsService = new EnumsService();
		let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, 'ENU_CON_TaskPart_DisplayMode', false);
		enumService.getAllByFilter(enumsFilter).then((response) => {
			this.SET_ID_DisplayMode = response.data.filter((c: any) => c.identifier == 'ENU_CON_TaskPart_DisplayMode_FitToTheScreen')[0].id;		
		});
		//nacteni zakladniho nastaveni info hlasek
		let enumsFilterIdposition: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, null, false, 'ENU_CON_TaskPart_Info_Position_Down');
		enumService.getAllByFilter(enumsFilterIdposition).then((response) => {
			this.SET_idInfoPosition = response.data[0].id;
		});
		let enumsFilterIdRotation: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, null, false, 'ENU_CON_TaskPart_Info_Rotation_Direction_Right');
		enumService.getAllByFilter(enumsFilterIdRotation).then((response) => {
			this.SET_idInfoRotationDirection = response.data[0].id;
		});
		let enumsFilterIdRotationSpeed: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, null, false, 'ENU_CON_TaskPart_Info_Rotation_Speed_Normal');
		enumService.getAllByFilter(enumsFilterIdRotationSpeed).then((response) => {
			this.SET_idInfoRotationSpeed = response.data[0].id;
		});
		let enumsFilterIdSize: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, null, false, 'ENU_CON_TaskPart_Info_Size_Medium');
		enumService.getAllByFilter(enumsFilterIdSize).then((response) => {
			this.SET_idInfoSize = response.data[0].id;
		});

		//zmenil jsem nastaveni z global
		let settingFilter: SettingFilter = new SettingFilter('CON', true, false, false, this.$store.state.idTenant, null, null);
		this.settingService.getAllByFilter(settingFilter).then((response) => {
			let responseData = response.data as any[];
			let refreshTimeImage = responseData.filter((c: any) => c.identifier == 'SET_Content_Image_Display_Time_In_Second')[0].defaultValue as number;
			this.SET_Display_Image = new Date(refreshTimeImage * 1000).toISOString().substr(11, 8);

			let refreshTimeHtml = responseData.filter((c: any) => c.identifier == 'SET_Content_HtmlContent_Display_Time_In_Second')[0].defaultValue as number;
			this.SET_Display_Html = new Date(refreshTimeHtml * 1000).toISOString().substr(11, 8);

			let refreshTimeUrl = responseData.filter((c: any) => c.identifier == 'SET_Content_LinkToUrl_Display_Time_In_Second')[0].defaultValue as number;
			this.SET_Display_Url = new Date(refreshTimeUrl * 1000).toISOString().substr(11, 8);

			let refreshIntervalUrl = responseData.filter((c: any) => c.identifier == 'SET_Content_LinkToUrl_Refresh_Interval_In_Second')[0].defaultValue as number;
			this.SET_Refresh_Url = new Date(refreshIntervalUrl * 1000).toISOString().substr(11, 8);

			let refreshIntervalInfoText = responseData.filter((c: any) => c.identifier == 'SET_Content_InfoText_Refresh_Interval_In_Second')[0].defaultValue as number;
			this.SET_Refresh_InfoText = new Date(refreshIntervalInfoText * 1000).toISOString().substr(11, 8);

			let refreshTimeOthers = responseData.filter((c: any) => c.identifier == 'SET_Content_Other_Display_Time_In_Second')[0].defaultValue as number;
			this.SET_Display_Other = new Date(refreshTimeOthers * 1000).toISOString().substr(11, 8);

			let durationVideo = responseData.filter((c: any) => c.identifier == 'SET_Content_Minimum_Display_Time_In_Second')[0].defaultValue as number;
			this.SET_Video_Length = new Date(durationVideo * 1000).toISOString().substr(11, 8);
		});

	}

	newItemId: number = -1;
	protected selectedContentItemsBase(items: any): void {
		let maxOrder: number = 1;
		var formHeadOne = this.formDataContentHead.filter(c => c.id == this.idTableAdd)[0];
		maxOrder = formHeadOne.contents.filter((c: iFormDataContent) => c.inTheInfoLine == this.inTheInfoLine).reduce((order, obj) => {
			return obj.order > order ? obj.order : order;
		}, 0);
		for (var i = 0; i < items.length; i++) {
			if (formHeadOne.contents.filter((c: iFormDataContent) => c.inTheInfoLine == this.inTheInfoLine).filter((c: any) => c.id == items[i]).length == 0) {
				formHeadOne.isEditContentDetail = this.isEditContentDetail = true;
				var conItem = this.contentsAll.filter((c: any) => c.id == items[i])[0] as any;

				let refreshInterval = '00:00:00';
				let duration = this.SET_Display_Other;
				if (conItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Image') {
					duration = this.SET_Display_Image;
				}
				if (conItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_HtmlContent') {
					duration = this.SET_Display_Html;
				}
				if (conItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_LinkToUrl') {
					duration = this.SET_Display_Url;
					refreshInterval = this.SET_Refresh_Url;
				}
				if (conItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_InfoText') {
					refreshInterval = this.SET_Refresh_InfoText;
				}

				if (conItem.idContentTypeIdentifier == 'ENU_CON_Content_Type_Video') {
					duration = conItem.idContentVariantLength;
					if (conItem.idContentVariantLength < this.SET_Video_Length) {
						duration = this.SET_Video_Length;
					}
				}

				maxOrder++;
				this.newItemId = this.newItemId - 1;
				var addItem: iFormDataContent = {
					//VaP - zde byl problem, ze pokud tu bylo id 0 a pridam vic jak jednu polozku, tak vsechny maji id 0 a tim padem narp smazani zrusi vsechny polozky s id 0
					//    - tim padem nove polozky maji zaporne id a kazde id by melo byt jedinecne, po uloze se jim jiz nastavi id z DB
					icon: conItem.icon,
					id: this.newItemId,
					idTenant: this.$store.state.idTenant as number,
					duration: duration,
					exceptionText: '',
					mute: false,
					streamBufferInSeconds: null,
					backgroundColor: '#FFFFFF',
					idContent: conItem.id,
					idContentNavigationName: conItem.name,
					idContentTypeNavigationIdentifier: conItem.idContentTypeIdentifier,
					idContentTypeNavigationName: conItem.idContentTypeNavigationName,
					idDisplayMode: this.SET_ID_DisplayMode,
					idSchedule: 0,
					idTask: this.formData.id,
					image: conItem.image,
					order: maxOrder,

					idContentPreviewGridStatic: conItem.idContentPreviewGridStatic,
					idContentPreviewGridAnimated: conItem.idContentPreviewGridAnimated,
					idContentPreviewTableStatic: conItem.idContentPreviewTableStatic,
					idContentPreviewTableAnimated: conItem.idContentPreviewTableAnimated,
					contentPreviewAlt: conItem.contentPreviewAlt,
					contentPreviewTitle: conItem.contentPreviewTitle,

					inTheBackground: this.newTaskPartInBackground,
					refreshInterval: refreshInterval,
					suppressBackground: true,//formHeadOne.inTheBackground
					showWarningInOffline: true,
					//informacni text
					inTheInfoLine: this.inTheInfoLine,
					idInfoPosition: -1,
					idInfoRotationDirection: -1,
					idInfoRotationSpeed: -1,
					idInfoSize: -1,
					textColor: '#000000',
					delay: 10,
					isCanceled: conItem.isCanceled,
					idCancelationReason: conItem.idCancelationReason,
					idCancelationReasonText: conItem.idCancelationReasonText
				}
			
	
				formHeadOne.contents.push(addItem);
				//setrideni order
				this.changeOrderNumber(formHeadOne);
			}
		}
	}

	fieldsContentInfo = [
		{ key: 'idContent', label: this.$t('taskDetail.fieldOrder'), trans: 'taskDetail.fieldOrder', sortable: false, class: 'text-center helpWidth60 ', design: 'moveUpDown' },
		//{ key: 'image', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center columnImage ', design: 'onlyImage', showOn: 0 },
		{ key: 'idContentNavigationName', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', sortable: false, class: 'text-center ', design: 'detail' },
		{ key: 'idContentTypeNavigationName', label: this.$t('taskDetail.fieldType'), trans: 'taskDetail.fieldType', sortable: false, class: 'text-center helpWidth180', optional: false, visible: true, design: 'useIcon' },
		{ key: 'duration', label: this.$t('taskDetail.fieldLength'), trans: 'taskDetail.fieldLength', sortable: false, class: 'text-center', formatter: (x: Date) => tlISOTimeToLocalStringForm(x), optional: false, visible: true },
		{ key: 'actions', label: '', sortable: false, class: 'text-right' }
	];

	fieldsContent = [
		//columnImage
		//{ key: 'id', label: 'id', sortable: true, class: 'text-center', optional: true, visible: true },
		//{ key: 'order', label: 'Pořadí test', sortable: true, class: 'text-center', optional: true, visible: true },

		{ key: 'idContent', label: this.$t('taskDetail.fieldOrder'), trans: 'taskDetail.fieldOrder', sortable: false, class: 'text-center helpWidth60 ', design: 'moveUpDown' },
		{ key: 'image', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center columnImage ', design: 'onlyImage', showOn: 1 },
		{ key: 'idContentNavigationName', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', sortable: false, class: 'text-center ', design: 'detail' },
		{ key: 'idContentTypeNavigationName', label: this.$t('taskDetail.fieldType'), trans: 'taskDetail.fieldType', sortable: false, class: 'text-left ', optional: false, visible: true, design: 'useIcon' },

		//{ key: 'idContentTypeNavigationName', label: this.$t('content.fieldType'), sortable: true, class: 'text-center helpWidth180', trans: 'content.fieldType', design: 'useIcon' },

		{ key: 'duration', label: this.$t('taskDetail.fieldLength'), trans: 'taskDetail.fieldLength', sortable: false, class: 'text-center', formatter: (x: Date) => tlISOTimeToLocalStringForm(x), optional: false, visible: true },
		
		{ key: 'suppressBackground', label: this.$t('taskDetail.fieldSupress'), trans: 'taskDetail.fieldSupress', sortable: false, class: 'text-center helpWidth30 ', design: 'checkBox', showOn: 1 },
		{ key: 'actions', label: '  ', sortable: false, class: 'text-right' },
	];

	fieldsContentModal = [
		//{ key: 'id', label: 'id', sortable: true, class: 'text-center', optional: true, visible: true },
		{ key: 'image', label: this.$t('taskDetail.fieldId'), trans: 'taskDetail.fieldId', sortable: false, class: 'text-center columnImage', design: 'popupImage', action: 'notClick' },
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', sortable: true, class: 'text-center' },
		{ key: 'idContentTypeNavigationName', label: this.$t('taskDetail.fieldType'), trans: 'taskDetail.fieldType', sortable: true, class: 'text-center helpWidth180', design: 'useIcon' },
		{ key: 'idContentVariantParameters', label: this.$t('taskDetail.fieldParams'), trans: 'taskDetail.fieldParams', sortable: true, class: 'text-center', optional: false, visible: true, design: 'columnBackGround' },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', sortable: true, class: 'text-left', design: 'tags', action: 'filter', tooltip: 'tags' },
	];

	filtersContentModal = [
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', selected: false, value: null, type: 'multi', multiselect: true },
		//TODO predelat
		{ key: 'idContentTypeIdentifier0', label: this.$t('taskDetail.typeMediaAudio'), trans: 'taskDetail.typeMediaAudio', selected: true, value: 'ENU_CON_Content_Type_Audio', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Typ', isNegative: true },
		{ key: 'idContentTypeIdentifier1', label: this.$t('taskDetail.typeMediaAudioStream'), trans: 'taskDetail.typeMediaAudioStream', selected: true, value: 'ENU_CON_Content_Type_AudioStream', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Typ', isNegative: true },
		{ key: 'idContentTypeIdentifier2', label: this.$t('taskDetail.typeMediaHtml'), trans: 'taskDetail.typeMediaHtml', selected: true, value: 'ENU_CON_Content_Type_HtmlContent', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },

		{ key: 'idContentTypeIdentifier4', label: this.$t('taskDetail.typeMediaImage'), trans: 'taskDetail.typeMediaImage', selected: true, value: 'ENU_CON_Content_Type_Image', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
		{ key: 'idContentTypeIdentifier5', label: this.$t('taskDetail.typeMediaUrl'), trans: 'taskDetail.typeMediaUrl', selected: true, value: 'ENU_CON_Content_Type_LinkToUrl', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
		{ key: 'idContentTypeIdentifier6', label: this.$t('taskDetail.typeMediaVideo'), trans: 'taskDetail.typeMediaVideo', selected: true, value: 'ENU_CON_Content_Type_Video', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: 'Nezobrazovat  typ', isNegative: true },
		{ key: 'idContentTypeIdentifier7', label: this.$t('taskDetail.typeMediaScreenOff'), trans: 'taskDetail.typeMediaScreenOff', selected: true, value: 'ENU_CON_Content_Type_ScreenOff', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
		{ key: 'idContentTypeIdentifier8', label: this.$t('taskDetail.typeMediaNothing'), trans: 'taskDetail.typeMediaNothing', selected: true, value: 'ENU_CON_Content_Type_Nothing', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
	];


	filtersContentModalBlock2 = [
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', selected: true, value: null, type: 'text', isEditable: true },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', selected: false, value: null, type: 'multi', multiselect: true },
		//TODO predelat
		{ key: 'idContentTypeIdentifier0', label: this.$t('taskDetail.typeMediaAudio'), trans: 'taskDetail.typeMediaAudio', selected: true, value: 'ENU_CON_Content_Type_Audio', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Typ', isNegative: true },
		{ key: 'idContentTypeIdentifier1', label: this.$t('taskDetail.typeMediaAudioStream'), trans: 'taskDetail.typeMediaAudioStream', selected: true, value: 'ENU_CON_Content_Type_AudioStream', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: 'Typ', isNegative: true },
		{ key: 'idContentTypeIdentifier8', label: this.$t('taskDetail.typeMediaNothing'), trans: 'taskDetail.typeMediaNothing', selected: true, value: 'ENU_CON_Content_Type_Nothing', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
	];



	filtersContentModalInfo = [
		{ key: 'name', label: this.$t('taskDetail.fieldName'), trans: 'taskDetail.fieldName', selected: true, value: null, type: 'text', isEditable: true },
		{ key: 'tags', label: this.$t('taskDetail.fieldTags'), trans: 'taskDetail.fieldTags', selected: false, value: null, type: 'multi', multiselect: true },
		{ key: 'idContentTypeIdentifier3', label: this.$t('taskDetail.typeMediaInfoText'), trans: 'taskDetail.typeMediaInfoText', selected: true, value: 'ENU_CON_Content_Type_InfoText', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
		{ key: 'idContentTypeIdentifier8', label: this.$t('taskDetail.typeMediaNothing'), trans: 'taskDetail.typeMediaNothing', selected: true, value: 'ENU_CON_Content_Type_Nothing', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), isNegative: true },
	];
	//end prehravane MEDIA

	formData = {
		id: 0 as number,
		isTypeTaskInIdleState: false as boolean,
		idTenant: this.$store.state.idTenant as number,
		name: '' as string,
		description: '' as string,
		validFrom: '' as string | null,
		validFromText: '' as string | null,
		creationDate: '' as string | null,
		whenChanged: '' as string | null,
		validTo: '' as string | null,
		validToText: '' as string | null,
		idTaskType: -1 as number | null,
		idTaskTypeText: '' as string,
		dateOfDelegation: '' as string | null,
		idTaskStateNavigationName: '' as string,
		canStop: false as boolean,
		canDelegate: false as boolean,
		canChange: false as boolean,
		canActivate: false as boolean,
		isPriorityTask: false as boolean,
		isInIdleTask:false as boolean,
		isDelegatedToComponents: false as boolean,
		isActive: false as boolean,
		isNotAllowEdit: false as boolean,
		isPlayingTask: false as boolean,
		tags: null,
		isSendTask: false as boolean,
		isStoped: false as boolean,
		isChanged: false as boolean,
		isPreparing: false as boolean,
		isNew: false as boolean,
	};

	dateOfDelegation = '' as string | null;

	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	protected createdBase(): void {

		this.loadSetting();
		if (!this.styleFormNew && this.hasRight) {
			this.loadReceivers();
			//	this.loadContents();//TODO pryc
			this.loadContentsBlock();
		}

		//VaP - az je nastaveno id a nejsou disable zalozky, tak zkusime zapnout zalozku podle hodnoty v params, pokud nebyla nastavena jiz driv
		if (this.$router.currentRoute.params.tabName) {
			if (this.activeTabName == '') {
				this.activeTabName = this.$router.currentRoute.params.tabName;
			}
		}
	}

	save(): void {
		if (this.styleFormNew) {
			this.createObject().then(res => {
				this.processResponse(res.data);
				//zalozeni prvního bloku
				var block = res.data.taskBlock;
				var newItem: iFormDataContentHead = {
					isEditContentDetail: false,
					isAllowException: this.allowEditBlockBase(),
					id: block.id,
					idNew: 0,
					isNewBlock: false,
					name: 'Blok médií 1',
					description: '',
					inTheBackground: false,
					inTheInfoLine: false,
					timeFrom: '00:00',
					timeTo: '23:59',
					week: this.deepCopy({
						monday: this.getDay('monday', this.$t('baseTableEditable.day1').toString()),
						tuesday: this.getDay('tuesday', this.$t('baseTableEditable.day2').toString()),
						wednesday: this.getDay('wednesday', this.$t('baseTableEditable.day3').toString()),
						thursday: this.getDay('thursday', this.$t('baseTableEditable.day4').toString()),
						friday: this.getDay('friday', this.$t('baseTableEditable.day5').toString()),
						saturday: this.getDay('saturday', this.$t('baseTableEditable.day6').toString()),
						sunday: this.getDay('sunday', this.$t('baseTableEditable.day7').toString()),
					}),

					exceptionText: '',
					idSchedule: block.idSchedule,
					idTask: res.data.id,
					contents: []
				}
				this.formDataContentHead.push(newItem);
				this.formDataContentHeadOld.push(this.deepCopy(newItem));

				this.formData.id = res.data.id;
				this.formData.whenChanged = tlISODateTimeToLocalNoSecondsString(res.data.whenChanged);
				this.styleFormDetail = true;
				this.styleFormNew = false;
				this.setTypeTaskText();
				this.formData.canDelegate = true; // delegovat ma být povoleno hned po vytvoření
				this.$store.commit("mainDataChanged", false);
			});

			this.styleFormNew = false;
			this.styleFormDetail = true;
		}
		else {
			this.updateTask();
		}
		this.goToEdit();
	}

	protected fetchData() {
		this.fetchTaskData();
	}

	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('taskDetail.messageNew').toString(), this.$t('taskDetail.messageEdit').toString(), this.$t('taskDetail.messageDelete').toString());
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		this.$store.commit("mainDataChanged", false);
		this.$store.commit("mainDataChangedSub", false);
		return this.taskService.delete(this.objectId);
	}

	async delegateAndActivate() {
		this.isBusy = true;	
		if (!this.isEditContentDetail && !this.isEditReceiverDetail) {
			this.onlyActivateAndDelegate();
		}
		else {
			if (this.isEditContentDetail && !this.isEditReceiverDetail) {
				this.saveContentBlockDetailBase(0, true, false, true);
			}
			if (this.isEditReceiverDetail) {
				this.saveReceiversDetail(false).then(res => {
					if (this.isEditContentDetail) {
						this.saveContentBlockDetailBase(0, true, false, true);
					}
					else {
						this.onlyActivateAndDelegate();
					}
				});
			}
		}
	}

	onlyActivateAndDelegate() {
			this.taskService.delegateAndActivate(this.objectId).then((response) => {
				this.setProgressIconsReceiverToStart();
				this.processResponse(response.data);
				this.isBusy = false;
			}).catch((error) => {
				this.isBusy = false;
				this.showErrorMessage(error, this.$t('taskDetail.errorActivateTask').toString());
			});
	
	}

	onlyDelegate() {
		this.setProgressIconsReceiverToStart();
		this.taskService.delegate(this.objectId).then((response) => {
			this.processResponse(response.data);
			this.isBusy = false;
		}).catch((error) => {
			this.isBusy = false;
			this.showErrorMessage(error, this.$t('taskDetail.errorDelegateTask').toString());
		});
	}

	//TODO neprisel jsem jak to vyresit aby to fungovalo elegantneji delegatePuvodni
	async delegate() {
		this.isBusy = true;
		//zmena bloky i obrazovky
		if (this.isEditContentDetail && this.isEditReceiverDetail) {		
		
			this.saveContentBlockDetailBase(0, true, false).then(res => {
				this.saveReceiversDetail(!this.formData.isNew).then(res => {
					this.isBusy = false;
					if (this.formData.isNew) {
						this.onlyDelegate();
					}
				});
			});
		}  //zmena jen v blocich
		else if (this.isEditContentDetail) {
			this.saveContentBlockDetailBase(0, true, !this.formData.isNew).then(res => {	
				this.isBusy = false;
				//presun primo do saveContent
				if (this.formData.isNew) {
					this.onlyDelegate();
				}
			});
		} //zmena jen v receiverech
		else if (this.isEditReceiverDetail) {
			this.saveReceiversDetail(!this.formData.isNew).then(res => {
				this.isBusy = false;
				if (this.formData.isNew) {
					this.onlyDelegate();
				}
			});
		}
		else {  //delegovani bez ulozeni zmen		
			this.onlyDelegate();
		}
	}

	//bohuzel nefunguje jak ma preskoci to krok saveContent pred dokoncenim a....
	async delegatePUVODNI() {
		this.isBusy = true;
		var result = true;
		if (this.isEditContentDetail) {
			//result = await this.saveContentDetailBase();
			result =  await this.saveContentBlockDetailBase(0, true);
		}
		if (this.isEditReceiverDetail) {
			result = result && await this.saveReceiversDetail(false);
		}
		if (result) {
			this.setProgressIconsReceiverToStart();
			this.taskService.delegate(this.objectId).then((response) => {
				this.processResponse(response.data);
				this.isBusy = false;
			}).catch((error) => {
				this.isBusy = false;
				this.showErrorMessage(error, this.$t('taskDetail.errorDelegateTask').toString());
			});
		}
		else {
			this.isBusy = false;
			this.showErrorMessage('', this.$t('taskDetail.errorDelegateTask').toString());
		}
	}

	showDelegateButton() {
		var priorityTask = this.formData.isPriorityTask && (this.formData.isNew || this.formData.isChanged || this.formData.isStoped);
		var normalTask = !this.styleFormDelete && !this.formData.isPriorityTask;
		
		return (normalTask || priorityTask)
			&& (this.formData.canDelegate || (this.formData.isSendTask && (this.isEditContentDetail || this.isEditReceiverDetail)) || this.isEditContentDetail)
			&& this.hasReceivers() && this.hasContent() && this.controlIsDaySelected();;
	}

	showPlayButton() {
		var priorityTask = this.formData.isPriorityTask && !this.formData.isActive && !this.formData.canDelegate && (this.formData.isSendTask || this.formData.isChanged || this.formData.isNew || this.formData.isStoped);
		var normalTask = this.formData.canActivate && !this.formData.isPriorityTask	&& this.formData.isDelegatedToComponents;
		return (priorityTask || normalTask) && !this.styleFormDelete && this.hasReceivers() && this.hasContent() && this.controlIsDaySelected();
	}

	//spusteni prioritni
	showDelegateAndActivateButton() {
		return this.formData.isPriorityTask && this.formData.canDelegate && (this.formData.isSendTask || this.formData.isChanged || this.formData.isNew || this.formData.isStoped) && this.hasReceivers() && this.hasContent();
	}


	controlIsDaySelected(): boolean {
		for (var i = 0; i < this.formDataContentHead.length; i++) {
			if (this.formDataContentHead[i].week.monday.selected || this.formDataContentHead[i].week.tuesday.selected || this.formDataContentHead[i].week.wednesday.selected || this.formDataContentHead[i].week.thursday.selected ||
				this.formDataContentHead[i].week.friday.selected || this.formDataContentHead[i].week.saturday.selected || this.formDataContentHead[i].week.sunday.selected) {
				return true;
			}
			//TODO puvodni
			//if (this.contents[i].week.monday.selected || this.contents[i].week.tuesday.selected || this.contents[i].week.wednesday.selected || this.contents[i].week.thursday.selected ||
			//	this.contents[i].week.friday.selected || this.contents[i].week.saturday.selected || this.contents[i].week.sunday.selected) {
			//	return true;
			//            }
		}
		return false;
	}

	hasContent(): boolean {
		return this.formDataContentHead.some(item => item.contents != null && item.contents.length > 0);
	}

	hasReceivers(): boolean {
		return this.receivers.length > 0;
	}

	activate() {
		this.isBusy = true;
		this.taskService.activateTask(this.objectId).then((response) => {
			this.isBusy = false;
			this.processResponse(response.data);
		}).catch((error) => {
			this.showErrorMessage(error, this.$t('taskDetail.errorActivateTask').toString());
			this.isBusy = false;
		});
	}

	stopTask() {
		this.isBusy = true;
		this.taskService.stopTask(this.objectId).then((response) => {
			this.isBusy = false;
			this.processResponse(response.data);
		}).catch((error) => {
			this.showErrorMessage(error, this.$t('taskDetail.errorStopTask').toString());
			this.isBusy = false;
		});
	}

	showStopTaskButton() {
		var isPriorityTask = (this.formData.canStop &&  this.formData.isPriorityTask && (this.formData.isPlayingTask || this.formData.isChanged || this.formData.isPreparing));
		var isNormalTask = (this.formData.canStop && !this.formData.isPriorityTask);
		return !this.styleFormDelete && (isNormalTask || isPriorityTask);
	}

	//VaPTODO - nepouzivana metoda smazat
	isObjectId(): boolean {
		return this.paramId() > 0 || this.formData.id > 0;
	}

	paramId(): number {
		var result = this.objectIdFromParam == NaN ? this.formData.id : this.objectIdFromQuery;
		return result;
	}

	paramIdIsNumber(): boolean {
		let value = this.$router.currentRoute.query.id;
		return ((value != null) &&
			(value !== '') &&
			!isNaN(Number(value.toString())));
	}

	fetchTaskData() {
		if (!this.styleFormNew && this.hasRight && this.paramIdIsNumber()) {
			this.taskService.getById(this.paramId()).then((response) => {
				this.processResponse(response.data);
				//VaP - az je nastaveno id a nejsou disable zalozky, tak zkusime zapnout zalozku podle hodnoty v params, pokud nebyla nastavena jiz driv
				if (this.$router.currentRoute.params.tabName) {
					if (this.activeTabName == '') {
						this.activeTabName = this.$router.currentRoute.params.tabName;
					}
				}
			}).catch((error) => {
				this.showErrorMessage(error);
			});
		}
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.taskService.getRefreshById(this.objectId);
	}

	refreshItems(items: any, refreshData: any): any {
		items.canChange = refreshData.canChange;
		items.idTaskStateNavigationName = refreshData.idTaskStateNavigationName;
		items.screenList = refreshData.screenList;
		items.isNotAllowEdit = refreshData.isNotAllowEdit;

		items.isSendTask = refreshData.isSendTask;
		items.isStoped = refreshData.isStoped;
		items.canStop = refreshData.canStop;
		items.canDelegate = refreshData.canDelegate;
		items.isChanged = refreshData.isChanged;
		items.isPreparing = refreshData.isPreparing;
		items.isNew = refreshData.isNew;
		items.isPlayingTask = refreshData.isPlayingTask;
		items.isPriorityTask = refreshData.isPriorityTask;


		for (var i = 0; i < refreshData.receiversList.length; i++) {
			var itemsList = this.receivers.filter((c: any) => c.id == refreshData.receiversList[i].id);
			if (itemsList.length > 0) {
				var itemChange = (this.receivers.filter((c: any) => c.id == refreshData.receiversList[i].id)[0] as any);
				itemChange.idComponentStateNavigationIdentifier = refreshData.receiversList[i].idComponentStateNavigationIdentifier;
				itemChange.idComponentStateNavigationName = refreshData.receiversList[i].idComponentStateNavigationName;
				itemChange.progressHelp = refreshData.receiversList[i].progressHelp;
				itemChange.progressError = refreshData.receiversList[i].progressError;
				itemChange.taskActualText = refreshData.receiversList[i].taskActualText;
				itemChange.taskActual = refreshData.receiversList[i].taskActual;
				itemChange.isTranscoded = refreshData.receiversList[i].isTranscoded;
				itemChange.fileSumCheckTable = refreshData.receiversList[i].fileSumCheckTable;

			}
		}
		return items;
	}

	//VaPTODO - prenest do predka  mozna az do predka predka;-)
	showErrorMessage(error: any, errorTitle: string = this.$t('taskDetail.errorLoadData').toString(), errorMessage: string = this.$t('taskDetail.errorCantLoadData').toString()) {

		if (error && error.data && error.data.errors) {
			errorMessage = this.errorMessageToString(error.data.errors, errorMessage);
		}
		this.showAlertModalWithTitleAndContent(errorTitle, errorMessage);
	}

	errorMessageToString(errorMessages: string[], errorMessage: string) {
		if (errorMessages && errorMessages.length > 0) {
			let returnvalue: string = errorMessages.join("<br>");
			return returnvalue;
		}
		return errorMessage;
	}

	allowEditBlockBase() {
		return this.formData.isTypeTaskInIdleState == false;
	}

	processResponse(response: any) {	
		this.formData.id = response.id;
		this.formData.isTypeTaskInIdleState = response.isTypeTaskInIdleState;
		this.formData.name = response.name;
		this.formData.description = response.description;
		this.formData.validFrom = tlISODateToLocalStringForm(response.validFrom);
		this.formData.validFromText = tlISODateToLocalString(response.validFrom);
		this.formData.creationDate = tlISODateTimeToLocalNoSecondsString(response.creationDate);
		this.formData.whenChanged = tlISODateTimeToLocalNoSecondsString(response.whenChanged);
		this.formData.validTo = tlISODateToLocalStringForm(response.validTo);
		this.formData.validToText = tlISODateToLocalString(response.validTo);
		this.formData.idTaskType = response.idTaskType;
		this.formData.idTaskTypeText = response.idTaskTypeText;
		this.dateOfDelegation = tlISODateTimeToLocalNoSecondsString(response.dateOfDelegation);
		this.formData.idTaskStateNavigationName = response.idTaskStateNavigationName;
		this.formData.canStop = response.canStop;
		this.formData.canDelegate = response.canDelegate;
		this.formData.canChange = response.canChange;
		this.formData.canActivate = response.canActivate;
		this.formData.isPriorityTask = response.isPriorityTask;
		this.formData.isInIdleTask = response.isInIdleTask;
		this.formData.isPlayingTask = response.isPlayingTask;
		this.formData.isDelegatedToComponents = response.isDelegatedToComponents;
		this.formData.isActive = response.isActive;
		this.formData.isNotAllowEdit = response.isNotAllowEdit;
		this.formData.tags = response.tags;
		this.formData.isSendTask = response.isSendTask;
		this.formData.isStoped = response.isStoped;
		this.formData.isChanged = response.isChanged;
		this.formData.isPreparing = response.isPreparing;
		this.formData.isNew = response.isNew;

	
		if (this.formData.idTaskTypeText == '') {
			this.setTypeTaskText();
		}
	

	}

	setTypeTaskText(): void {
		var elementSelected = (document.getElementById('idTaskType') as HTMLSelectElement);
		this.formData.idTaskTypeText = elementSelected.options[elementSelected.selectedIndex].text;
	}

	createTask() {
		this.formData.creationDate = this.formData.whenChanged = null;
		if (this.styleFormNew) {
			if (this.formData.validFrom == '') {
				this.formData.validFrom = null;
			}
			if (this.formData.validTo == '') {
				this.formData.validTo = null;
			}
			this.taskService.create(this.formData).then((response) => {
				this.processResponse(response.data);
				// VaP - po uspesnem vytvoreni noveho objektu nastavime formular do editacniho modu, abychom mohli zadavat i dalsi udaje
				this.styleFormDetail = true;
				this.styleFormNew = false;


				this.showAlertModalWithTitleAndContent('Info', 'Vytvořená nová úloha');
				this.$store.commit("mainDataChanged", false);
			}).catch((error) => {
				this.showErrorMessage(error);
			});
		}
	}

	updateTask() {
		this.formData.creationDate = this.formData.whenChanged = null;
		if (this.styleFormDetail) {
			if (this.formData.validFrom == '') {
				this.formData.validFrom = null;
			}
			if (this.formData.validTo == '') {
				this.formData.validTo = null;
			}
			this.taskService.update(this.objectId, this.formData).then((response) => {
				if ((response.data.errors as Array<any>).length > 0) {
					this.showErrorMessage(response, this.$t('taskDetail.errorSave').toString(), this.$t('taskDetail.errorSaveData').toString());
					this.goBackNotChange();
				}
				else {
					this.processResponse(response.data);
					this.isSuccessfully = true;
				}
				this.$store.commit("mainDataChanged", false);
			}).catch((error) => {
				this.isSuccessfully = false;
				this.showErrorMessage(error, this.$t('taskDetail.errorSave').toString(), this.$t('taskDetail.errorSaveData').toString());
			});
		}
	}

	vIsCorrectName: boolean = true;
	vIsCorrectTaskType: boolean = true;

	validateBase() {
		return !(
			this.vIsCorrectName
			&& this.vIsCorrectTaskType
		);
	}

	isCorrectNameBase(value: any) {
		this.vIsCorrectName = value;
	}

	isCorrectTaskTypeBase(value: any) {
		this.vIsCorrectTaskType = value;
	}

	isActiveTabBase(tabName: string): boolean {
		return this.activeTabName === tabName;
	}


	deleteBlockBase(idTable: any) {
		this.isDeletedBlock = true;

		this.formDataContentHead = this.formDataContentHead.filter(c => c.id != idTable);
		this.isEditContentDetail = true;
		//puvodni verze ktera hned smazala
		//this.taskBlockService.delete(idTable).then(res => {
		//	this.formDataContentHead = this.formDataContentHead.filter(c => c.id != idTable);
		//	this.formDataContentHeadOld = this.formDataContentHeadOld.filter(c => c.id != idTable);
		//	this.processResponse(res.data);
		//});
	}

	newBlockNumber = 0;
	idNewBlock = 0;
	newBlockBase() {
		this.isEditContentDetail = true;
		if (this.formDataContentHead.length > 0) {
			const max = this.formDataContentHead.reduce((prev, current) => {
				return (prev.id > current.id) ? prev : current
			});
			this.idNewBlock = max.id + 1;
		}
		else {
			this.idNewBlock = 1;
		}

		this.newBlockNumber = this.formDataContentHead.length + 1;
		var newItem: iFormDataContentHead = {
			isEditContentDetail: true,
			isAllowException: this.allowEditBlockBase(),
			id: this.idNewBlock,
			idNew: 0,
			isNewBlock: true,
			name: 'Blok médií ' + this.newBlockNumber,
			description: '',
			inTheBackground: false,
			inTheInfoLine: false,
			timeFrom: '00:00',
			timeTo: '23:59', 
			week: this.deepCopy(					{
						monday: this.getDay('monday', this.$t('baseTableEditable.day1').toString()),
						tuesday: this.getDay('tuesday', this.$t('baseTableEditable.day2').toString()),
						wednesday: this.getDay('wednesday', this.$t('baseTableEditable.day3').toString()),
						thursday: this.getDay('thursday', this.$t('baseTableEditable.day4').toString()),
						friday: this.getDay('friday', this.$t('baseTableEditable.day5').toString()),
						saturday: this.getDay('saturday', this.$t('baseTableEditable.day6').toString()),
						sunday: this.getDay('sunday', this.$t('baseTableEditable.day7').toString()),
					}),

			exceptionText: '',
			idSchedule: 0,
			idTask: this.formData.id,
			contents: []
		}
		this.formDataContentHead.push(newItem);
	}

	//rozdeleni order number na dve skupiny
	changeOrderNumber(formDataHead: iFormDataContentHead) {
		if (formDataHead.inTheBackground) {
			//TODO kdyz nezmenim nejakou property tak se mi neprojevi pridani prvku v dvojite verzi !!!!
			//TOHLE je zatim jen reseni co pomohlo ale urcite bude lepsi
			formDataHead.inTheBackground = !formDataHead.inTheBackground;
			formDataHead.inTheBackground = !formDataHead.inTheBackground;

			var skupinaA = formDataHead.contents.filter((c: iFormDataContent) => c.inTheBackground == false && c.inTheInfoLine == false).
			 sort((a, b) => (a.order > b.order) ? 1 : -1);


			var skupinaB = formDataHead.contents.filter((c: iFormDataContent) => c.inTheBackground == true && c.inTheInfoLine == false).
				sort((a, b) => (a.order > b.order) ? 1 : -1);

			var all = skupinaA.concat(skupinaB);

			var order = 0;
			for (var i = 0; i < all.length; i++) {
				order++;
				all[i].order = order;
			}
		}
	}

	inTheInfoLine = false;
	addBlockBase(idTable: any, blockNumber: any, isInfoText: boolean) {
		this.inTheInfoLine = isInfoText;
		this.initAllContents(idTable, blockNumber == 2, isInfoText);
		this.idTableAdd = idTable;
		var modalName = isInfoText == true ? "contentModalInfo" : blockNumber == 1 ? "contentModal" :"contentModalBlock2";
		this.$bvModal.show(modalName);
	}


}
